// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommentRepliesInner } from './comment-replies-inner';
import {
    CommentRepliesInnerFromJSON,
    CommentRepliesInnerFromJSONTyped,
    CommentRepliesInnerToJSON,
    CommentRepliesInnerToJSONTyped,
} from './comment-replies-inner';
import type { CommentStatus } from './comment-status';
import {
    CommentStatusFromJSON,
    CommentStatusFromJSONTyped,
    CommentStatusToJSON,
    CommentStatusToJSONTyped,
} from './comment-status';

/**
 * 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    comment_id: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    comment_text: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    created_at: string;
    /**
     * 
     * @type {Array<CommentRepliesInner>}
     * @memberof Comment
     */
    replies?: Array<CommentRepliesInner>;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    resolution_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    resolved_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    resolved_by?: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    section_reference: string;
    /**
     * 
     * @type {CommentStatus}
     * @memberof Comment
     */
    status: CommentStatus;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    vendor_company: string;
}



/**
 * Check if a given object implements the Comment interface.
 */
export function instanceOfComment(value: object): value is Comment {
    if (!('comment_id' in value) || value['comment_id'] === undefined) return false;
    if (!('comment_text' in value) || value['comment_text'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('section_reference' in value) || value['section_reference'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('vendor_company' in value) || value['vendor_company'] === undefined) return false;
    return true;
}

export function CommentFromJSON(json: any): Comment {
    return CommentFromJSONTyped(json, false);
}

export function CommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comment {
    if (json == null) {
        return json;
    }
    return {
        
        'comment_id': json['comment_id'],
        'comment_text': json['comment_text'],
        'created_at': json['created_at'],
        'replies': json['replies'] == null ? undefined : ((json['replies'] as Array<any>).map(CommentRepliesInnerFromJSON)),
        'resolution_comment': json['resolution_comment'] == null ? undefined : json['resolution_comment'],
        'resolved_at': json['resolved_at'] == null ? undefined : json['resolved_at'],
        'resolved_by': json['resolved_by'] == null ? undefined : json['resolved_by'],
        'section_reference': json['section_reference'],
        'status': CommentStatusFromJSON(json['status']),
        'user_id': json['user_id'],
        'vendor_company': json['vendor_company'],
    };
}

export function CommentToJSON(json: any): Comment {
    return CommentToJSONTyped(json, false);
}

export function CommentToJSONTyped(value?: Comment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment_id': value['comment_id'],
        'comment_text': value['comment_text'],
        'created_at': value['created_at'],
        'replies': value['replies'] == null ? undefined : ((value['replies'] as Array<any>).map(CommentRepliesInnerToJSON)),
        'resolution_comment': value['resolution_comment'],
        'resolved_at': value['resolved_at'],
        'resolved_by': value['resolved_by'],
        'section_reference': value['section_reference'],
        'status': CommentStatusToJSON(value['status']),
        'user_id': value['user_id'],
        'vendor_company': value['vendor_company'],
    };
}
